import { createContext } from 'react';
import { PAGE_REGISTRY, type PageRoute } from '@/site/pageRegistry';

// PRERENDER_ROUTES is derived from the single source of truth (PAGE_REGISTRY).
// To add an SEO landing page: add one entry to src/site/pageRegistry.ts, then add
// an eager import and a Route in App.tsx.
export const PRERENDER_ROUTES = PAGE_REGISTRY.map((p) => p.route) as ReadonlyArray<PageRoute>;

// React context that carries the current SSG route into AppRouter's StaticRouter.
// Using React context (not a module-level variable) prevents a race condition:
// vite-react-ssg renders multiple routes concurrently (concurrency=20 by default),
// so a shared module variable would be overwritten by the second route before the
// first finishes rendering. Each renderToPipeableStream call has its own context
// scope, so this is safe even with concurrent SSG tasks.
export const SsrRouteContext = createContext('/');

// Exported so the vite-react-ssg CLI picks it up from the entry file.
// The build reads `includedRoutes` (if present) to override the default path
// discovery and prerender exactly the allowlisted paths.
export const includedRoutes = (): string[] => [...PRERENDER_ROUTES];
